import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getMe } from "@/lib/api";

export default function AdminGuard({ children }) {
  const [state, setState] = useState({ loading: true, authenticated: false, user: null });

  useEffect(() => {
    getMe()
      .then((r) => setState({ loading: false, authenticated: !!r.authenticated, user: r.user || null }))
      .catch(() => setState({ loading: false, authenticated: false, user: null }));
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <Loader2 className="w-8 h-8 animate-spin text-[#0B1E36]" />
      </div>
    );
  }

  if (!state.authenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return typeof children === "function" ? children(state.user) : children;
}
